import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { CF_APPROVAL_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/cf-approval";

export const createCfApprovalV2 = (payload) => {
  return invokeApi(
    HTTP_METHODS.POST,
    `${CF_APPROVAL_HOSTNAME}${REST_URLS.CF_V2}`,
    payload
  );
};

export const getCfApprovalV2List = (params) => {
  return invokeApi(
    HTTP_METHODS.GET,
    `${CF_APPROVAL_HOSTNAME}${REST_URLS.CF_V2}`,
    null,
    params
  );
};

export const getCfApprovalV2ById = (id) => {
  return invokeApi(
    HTTP_METHODS.GET,
    `${CF_APPROVAL_HOSTNAME}${REST_URLS.CF_V2}/${id}`,
    null
  );
};

export const getCfFinancialById = (id) => {
  return invokeApi(
    HTTP_METHODS.GET,
    `${CF_APPROVAL_HOSTNAME}${REST_URLS.CF_FINANCIAL_UPLOAD}${id}`,
    null
  );
};

export const approveCfForm = (id, payload) => {
  return invokeApi(
    HTTP_METHODS.POST,
    `${CF_APPROVAL_HOSTNAME}${REST_URLS.CF_V2}${id}/approve`,
    payload
  );
};